import React from "react";

// Shared friendly "no data" block used across lists.
const EmptyState = ({ message = "Nothing to show yet.", icon = "🎾", action }) => {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-3 py-16 text-center">
      <div className="text-3xl">{icon}</div>
      <p className="text-sm text-muted">{message}</p>
      {action}
    </div>
  );
};

export default EmptyState;
